// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_KmPr1","secondaryColumnCell":"secondary-column-cell_KmPr1","input":"input_BMVq5","message":"message_zzSsD","tooltip":"tooltip_bUXH6"};